import { render, staticRenderFns } from "./SpreadViewerAccessOptions.vue?vue&type=template&id=14d6e79e"
import script from "./SpreadViewerAccessOptions.vue?vue&type=script&lang=js"
export * from "./SpreadViewerAccessOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14d6e79e')) {
      api.createRecord('14d6e79e', component.options)
    } else {
      api.reload('14d6e79e', component.options)
    }
    module.hot.accept("./SpreadViewerAccessOptions.vue?vue&type=template&id=14d6e79e", function () {
      api.rerender('14d6e79e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/spread-viewer-access-options/SpreadViewerAccessOptions.vue"
export default component.exports